import { startOfDay } from "date-fns";

export interface CalendarState {
  date: number;
}

export const initialState: CalendarState = {
  date: startOfDay(new Date()).getTime(),
};
